import { Link } from 'react-router-dom';
import clsx from 'clsx';

import { useLangLink } from '@hooks/useLangLink';

import { getMediaUrl } from '@utils/getMediaUrl';

import css from './Logo.module.scss';

const copyData = {
  logo: '/assets/icons/logo.svg',
};

const Logo = ({ inhrClass }) => {
  const { withLang } = useLangLink();

  const { logo } = copyData;

  return (
    <Link to={withLang('/')} className={clsx(css.logo, inhrClass)}>
      <img src={getMediaUrl(logo)} alt="" />
    </Link>
  );
};

export default Logo;
